import { BaseFieldWidget, ModelFieldType, SPI, ViewType } from '@kunlun/dependencies';
import { RemoveZeroTableFloatWidget } from './RemoveZeroTableFloatWidget';

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    viewType: [ViewType.Table],
    ttype: [ModelFieldType.Currency]
  })
)
export class RemoveZeroTableCurrencyWidget extends RemoveZeroTableFloatWidget {}
